import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Hero from '../components/nav/Hero'
import { useLocation } from 'react-router-dom'
import BlogList from '../components/posts/BlogList'
import FadeInSection from '../components/nav/FadeInSection'

function BlogPage() {
    const url = window.location.href
    const location = useLocation();

    useEffect(() => {
        const hash = location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 54);
            }
        }
    }, [location.hash]);
    return (
        <div>
            <Helmet>
                <title>Security Insights & Industry News | Guardhart Security Blog Kenya</title>
                <link rel="canonical" href={url} />
                <meta name="description" content="Stay updated with the latest security insights, industry news, and best practices from Guardhart Security. Expert tips on physical security, CCTV surveillance, close protection, and risk management in Kenya." />

                <meta property="og:type" content="website" />
                <meta property="og:url" content={url} />
                <meta property="og:title" content="Security Insights & Industry News | Guardhart Security Blog Kenya" />
                <meta property="og:description" content="Latest security insights, industry news, and best practices from Guardhart Security. Expert tips on physical security, CCTV surveillance, close protection, and risk management in Kenya." />

                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:title" content="Security Insights & Industry News | Guardhart Security Blog Kenya" />
                <meta property="twitter:description" content="Latest security insights, industry news, and best practices from Guardhart Security. Expert tips on physical security, CCTV surveillance, close protection, and risk management in Kenya." />
            </Helmet>
            <Hero
                label="Insights & Updates"
                title="Security knowledge, simplified."
                description="Tips, industry news, and updates from the Guardhart team. Stay informed on how to protect what matters most."
                primaryBtnText="Latest Posts"
                primaryBtnLink="#posts"
                showSecondaryBadge={false}
            />
            <FadeInSection>
                <BlogList />
            </FadeInSection>
        </div>
    )
}

export default BlogPage